module.exports = __webpack_public_path__ + "img/dlcw_img.4018bdc4.png";